import {
  Component,
  OnInit,
  HostListener,
  NgZone,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewChecked,
  Inject,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
  NgbTypeaheadSelectItemEvent
} from '@ng-bootstrap/ng-bootstrap';

import { Guid } from 'guid-typescript';

import {
  DnvMapState,
  LayerState,
  LayerType,
  BaseMapState,
  DnvSearchState,
  DnvFeatureLayer,
  DnvLegendState,
  FeatureClickedPayload,
  SetActiveLayer,
  Layer as DnvLayer,
  ToggleShowFilterPanel,
  SetAvailableLayer,
  DnvMapInfo,
  DnvMapAction,
  CenterMap,
  SetZoom,
  SetMapFeatureLayers,
  SearchItem,
  DnvMapActionType,
  SetSelectedItem,
  SetMapGeoJsonLayers,
  initialSearchItem,
  SetMapState,
  SetIcons,
  SetSearchItemsUrl,
  DnvBasemap,
  SetMapBasemaps,
  SetBaseMapSelected,
  CloseBasemaps,
  ToggleBasemaps,
  SelectBasemap,
  ToggleExpand,
  // SetFeatureLayerVisible, ToggleVisiblePayload,
  FeatureFilterPayload,
  QueryLayerFeatureCount,
  UpdateLayerFilter,
  ZoomToFeatures,
  HideFilterPanel,
  LoadLegendLayers,
  SetLayerFeatureVisible,
  FeatureLayerVisibilityPayload,
  SetActiveLegendLayers,
  LayerInfo,
  ToggleMetaDataPanel,
  SetMetaData,
  SetLayerInfo,
  SetMarkers,
  SetHighlightFeature,
  SetSelectedFeatureLayer,
  FeatureClicked,
  SelectFeature,
  SetSurroundingFeatureList,
  DnvGisUtility,
  SetTextStyle,
  AddText,
  TextStylePayload,
  DnvMapComponent,
  DrawShapes,
  StartDraw,
  UpdateStartDrawCircle,
  // Layer as DnvLayer,
  IsDrawing,
  SetOrthoOpacity,
  MapViewState,
  MapViewAction,
  MapViewLoad,
  noLoadedMapView,
  MapViewLoadDefault,
  MapViewLoadSharedId,
  MapViewCheckIsDirty,
  MapViewMarkDirty,
  MapViewSetUrlProvider,
  MapViewSetStoreWrapper,
  ClearLayerFilters,
  DnvBounds,
  SearchItemType,
  SetFeatureLayersOpacity,
  ShowingAOIShape,
  UpdateShapeOutlineColour,
  UpdateMarkerShape,
  UpdateShapeFillPattern,
  UpdateCircleRadius,
  ToggleEditShapes,
  SetLineStyle,
  UpdateFeatureLineStyle,
  UpdateFeatureStyle,
  SetAllTextStyle,
  DnvDrawnShapes,
  ResetSelected,
  BringToFront,
  BringToBack,
  DnvLatLng,
  DeleteFeature,
  SetFilterAOIShape,
  SetFilterAOIMode
} from 'dnv-lib';

import { Subject, Observable, forkJoin, of, EMPTY } from 'rxjs';
import {
  ApplicationState,
  ApplicationStatus,
  State,
  GetLayers,
  UserProfile,
  getMapState,
  getApplicationState,
  getPropertiesState,
  PropertiesState,
  Idle,
  getBasemaps,
  Layer,
  Table,
  Legend,
  CheckLayerDisplay,
  Search,
  SearchCoordinates,
  GetDBLink,
  GridSelectLayer,
  getGridSelectLayer,
  GridPayload,
  getGridSelectLayerCache,
  GetBasemaps,
  InvalidateGridCache,
  GetDataNames,
  DelayedAction,
  DelayedActionBy1,
  IdentifySurroundingFeature,
  SetSurroundingFeature,
  GetFeatureData,
  getLayerInfo,
  Draw,
  Export,
  SearchEngineerDrawings,
  ToastUserNotification,
  GetEngDrawingGeometry,
  SearchEngineerDrawingsByNum,
  SearchEngineerDrawingsByProj,
  Toolbox,
  getPropertiesInfo,
  PropertyInfo,
  getSelectedProperty,
  getPropertiesDBLink,
  GetShape,
  SearchCCTV,
  SetCCTV,
  SearchEngineerDrawingsByNumType,
  SelectedFeatureInspection,
  SetCCTVNotes,
  ToolboxStatus,
  SetToolboxStatus,
  GetMailMergeByProperty,
  ToolboxMailMerge,
  ToolboxMailMergeState,
  getToolboxMailMerge,
  ToolboxMailMergeArea,
  ToolboxMailMergeToggleParcelAtCoordinate,
  RefreshDisplayedGeoJson,
  GetMailMergeList,
  SearchReset,
  ToolboxMailMergeUpdateResultCount,
  ToolboxMailMergeOptions,
  ToolboxMailMergeUpdateOptions,
  GetCoordsByObjectId,
  SetFeatureRasterHighlight,
  getBaseMapState
} from 'src/app/state-management';
import { Action, Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  map,
  takeUntil,
  finalize
} from 'rxjs/operators';

// import { MsalService } from '@azure/msal-angular';
import { SearchedInfo } from 'src/app/models/search-info';
import { PrintService, SearchService } from 'src/app/services';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
// import { environment } from '../../../environments/environment';
import { Options } from '@angular-slider/ngx-slider';

import { AppStoreWrapper } from '../../models/AppStoreWrapper';
import { AppUrlProvider } from '../../models/AppUrlProvider';
import {
  Address,
  GetPropertyByAddress,
  GetPropertyByFolio,
  GetPropertyByXY,
  SetPropertyInfo,
  GetPropertyByPID,
  GetPropertyInfo,
  SetSelectedProperty,
  SetPropertiesDbLinks,
  PropertyAirSpace,
  GetPropertyBoundingBox,
  PrintSvcConn,
  GetServiceConnectionsByLatLong,
  SetPrintSvcConn,
  ResetGeoJsonProperty
} from 'src/app/state-management/properties';
import * as L from 'leaflet';
import '../../../../node_modules/leaflet.browser.print/dist/leaflet.browser.print.min.js';

@Component({
    selector: 'app-rap-view',
    templateUrl: './rap-view.component.html',
    styleUrls: ['./rap-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RapViewComponent implements OnInit, AfterViewInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();

  application$: Observable<ApplicationState>;
  mapState$: Observable<DnvMapState>;
  layerState$: Observable<LayerState>;
  legendState$: Observable<DnvLegendState>;
  baseMapState$: Observable<BaseMapState>;
  dnvSearchState$: Observable<DnvSearchState>;
  gridSelectLayer$: Observable<DnvFeatureLayer>;
  gridSelectLayerCache$: Observable<Map<string, GridPayload>>;
  layerInfo$: Observable<string>; // text for layer popup
  // textStyle$: Observable<TextStylePayload>;
  // _mapViewState: MapViewState;
  mapViewState$: Observable<MapViewState>;
  propertiesInfo$: Observable<any>;
  propertiesDBLink$: Observable<any>;
  mapViewState: MapViewState;
  selectedProperty$: Observable<string>;
  appUrlProvider: AppUrlProvider;
  appStoreWrapper: AppStoreWrapper;
  propertiesState$: Observable<PropertiesState>;
  propertiesState: PropertiesState;
  isDialogOpen = false;

  // mapViewState$: Observable<MapViewState>;
  lastSelectedFeature$: Observable<FeatureClickedPayload>;
  toolboxMailMerge$: Observable<ToolboxMailMergeState>;
  toolboxMailMergeState: ToolboxMailMergeState;

  ApplicationStatus = ApplicationStatus; // Expose the enum in the template
  ToolboxStatus = ToolboxStatus;

  validRapFeatureLayer$: Observable<boolean>;

  currentZoomLevel: number;
  applicationState: ApplicationState;
  layerState: LayerState;
  // _mapViewState: MapViewState;
  // isDialogOpen: boolean = false;
  featurePanelOpen: boolean;
  panelHeight: number;
  featureLayers: DnvFeatureLayer[];
  excludeFeatureInfo: string[];
  selectedFeature: any;
  isDrawing: boolean;
  formError: string;
  headerHeight = 0;
  contentHeight = 0;
  searchingProj = false;
  searchingNum = false;
  editingShape = '';
  filterAOILeafletId = 0;
  inspectionHeight: number;

  graphMeEndpoint = 'https://graph.microsoft.com/v1.0/me'; // demo
  userProfile: UserProfile = null;
  userIcon = '??';
  horizontalStripes: any;

  rapAssetLayerUID: string[] = [
    'STMN_BASINS',
    'STMN_MANHOLES',
    'STMN_CULVERTS',
    'STMN_MAINS',
    'STMN_CONN',
    'STMN_SERVICE_CONN_CAP',
    'SAN_DNV_MANHOLES',
    'SAN_INSPECTION_CHAMBERS',
    'SAN_SERVICE_CONN',
    'SAN_SERVICE_CONN_CAP',
    'SAN_MAINS',
    'SAN_LIFT_STATIONS',
    'WTR_VALVES',
    'WTR_HYDRANTS',
    'WTR_SERVICE_CONN',
    'WTR_SERVICE_CONN_CAP',
    'WTR_MAINS',
    'STMN_INSPECTION_INLETS',
    'STR_STAIRS',
    'STR_PEDESTRIAN_BRIDGES',
    'STMN_DRAINS',
    'STMN_SURFACE_CHANNELS',
    'TRN_OFFICIAL_TRAILS',
    'STR_WHARVES',
    'TRN_BUS_STOPS',
    'TRN_ROAD_SURFACE',
    'TRN_SIDEWALK'
  ];

  rapAssetEquivalent: string[] = [
    'STMN_NETWORK',
    'SAN_NETWORK',
    'WTR_NETWORK',
    'STR_PEDESTRIAN_BRIDGES',
    'STMN_INSPECTION_INLETS',
    'STR_STAIRS',
    'TRN_OFFICIAL_TRAILS',
    'STR_WHARVES',
    'TRN_BUS_STOPS',
    'TRN_ROAD_NETWORK'
  ];

  @ViewChild('fixedHeader') fixedHeader: ElementRef;
  @ViewChild('content') popup: TemplateRef<any>;
  @ViewChild('dnvMap') dnvMap: DnvMapComponent;

  public search: (text$: Observable<string>) => Observable<SearchItem[]>;
  public engDrawSearchNum: (
    searchNum$: Observable<string>
  ) => Observable<SearchItem[]>;
  public engDrawSearchProj: (
    searchProj$: Observable<string>
  ) => Observable<SearchItem[]>;
  public cctvSearch: (
    cctvSearch$: Observable<string>
  ) => Observable<SearchItem[]>;
  private selected: SearchItem = initialSearchItem;
  private readonly defaultIcon = 'far fa-question-circle';
  legendState: DnvLegendState;
  searchForm: UntypedFormGroup;
  engSearchForm: UntypedFormGroup;
  cctvSearchForm: UntypedFormGroup;

  dnvSearchState: DnvSearchState;
  mapState: DnvMapState;
  currentLayerInfo: LayerInfo;
  modal: NgbModalRef = null;
  color = '#000000';
  selectedColor = '';
  colorSwatches: string[][];
  sliderControl: UntypedFormControl = new UntypedFormControl(180);
  sliderOptions: Options = {
    floor: 0,
    ceil: 359,
    step: 10
  };
  bufferSliderOptions: Options = {
    floor: 0,
    ceil: 1000,
    step: 1,
    translate: (value: number): string => {
      return value + 'm';
    }
  };

  textStyle: TextStylePayload;
  fontFace = ['Arial', 'Courier New', 'Georgia', 'Verdana'];
  drawBtn = 'cancel';
  circleRadius: UntypedFormControl = new UntypedFormControl(0);
  hideFeedback = false;
  isDesktop = false;
  mapViewViewName = '';
  markerOptions = ['circle', 'plus', 'diamond', 'square', 'triangle', 'x'];
  selectedFontSize: number;
  layerOpacity = 1;
  dblink: string;
  ltopid: string;
  multiPlan = false;
  mapTitle: string;
  mapSubTitle: string;
  mapBorder = false;

  // Format the autosuggested item into a string for the input control
  formatter = (x: { name: string }) => x.name;

  constructor(
    private httpClient: HttpClient, // for demo purpose, should not be here
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    // private authService: MsalService,
    private configService: ConfigService,
    private store: Store<State>,
    private searchService: SearchService,
    private modalService: NgbModal,
    private gisUtility: DnvGisUtility,
    private printService: PrintService,
    private zone: NgZone,
    private elementRef: ElementRef
  ) {
    this.application$ = this.store.select(getApplicationState);
    this.mapState$ = this.store.select('mapState');
    this.layerState$ = this.store.select('layerState');
    this.legendState$ = this.store.select('legendState');
    this.baseMapState$ = this.store.select(getBaseMapState);
    this.dnvSearchState$ = this.store.select('dnvSearchState');
    this.gridSelectLayer$ = this.store.select(getGridSelectLayer);
    this.gridSelectLayerCache$ = this.store.select(getGridSelectLayerCache);
    this.layerInfo$ = this.store.select(getLayerInfo);
    this.mapViewState$ = this.store.select('mapViewState');
    this.propertiesInfo$ = this.store.select(getPropertiesInfo);
    this.selectedProperty$ = this.store.select(getSelectedProperty);
    this.propertiesDBLink$ = this.store.select(getPropertiesDBLink);
    this.propertiesState$ = this.store.select(getPropertiesState);
    this.toolboxMailMerge$ = this.store.select(getToolboxMailMerge);
    this.searchForm = new UntypedFormGroup({
      addressSearch: new UntypedFormControl('')
    });

    this.engSearchForm = new UntypedFormGroup({
      engDrawSearchNum: new UntypedFormControl(''),
      engDrawSearchProj: new UntypedFormControl('')
    });

    this.cctvSearchForm = new UntypedFormGroup({
      cctvSearch: new UntypedFormControl('SANMN')
    });
  }

  ngOnInit(): void {
    this.mapState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: DnvMapState) => {
        this.currentZoomLevel = state.zoomLevel;
        this.mapState = state;
        this.isDrawing = state.isDrawing;
        this.textStyle = state.textStyle;
        this.color = state.textStyle.color;
        this.sliderControl.setValue(state.textStyle.rotation);
        this.selectedFontSize = Number(state.textStyle.fontSize);
        if (state.filterAOIMode && state.filterAOIMode.shape) {
          this.filterAOILeafletId = state.filterAOIMode.shape.leafletId
            ? state.filterAOIMode.shape.leafletId
            : 0;
        }

        if (state.selectedFeatureLayer.url.length > 0) {
          const uId = this.mapState.featureLayers.filter(f => {
            if (f.url === state.selectedFeatureLayer.url) {
              return f;
            }
          })[0];
          if (uId && this.rapAssetLayerUID.includes(uId.uid)) {
            this.validRapFeatureLayer$ = of(true);
          } else {
            this.validRapFeatureLayer$ = of(false);
          }
        } else {
          this.validRapFeatureLayer$ = of(false);
        }
      });

    this.application$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: ApplicationState) => {
        if (
          this.applicationState &&
          this.applicationState.status !== state.status
        ) {
          this.store.dispatch(
            new ShowingAOIShape(state.status === ApplicationStatus.Layer)
          );
        }
        this.applicationState = state;
        this.setHeaderHeight();
      });

    this.dnvSearchState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: DnvSearchState) => {
        this.dnvSearchState = state;
      });

    this.layerState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: LayerState) => {
        this.layerState = Object.assign({}, state, {
          layers: state.layers.filter(l =>
            this.rapAssetEquivalent.includes(l.uid)
          )
        });
      });

    this.legendState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((legendState: DnvLegendState) => {
        this.legendState = legendState;
      });

    this.propertiesState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((propertiesState: PropertiesState) => {
        this.propertiesState = propertiesState;
      });

    this.layerInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((layerInfo: string) => {
        if (layerInfo.length > 0) {
          this.open(this.popup);
        }
      });

    this.propertiesDBLink$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((propertiesAirSpace: PropertyAirSpace[]) => {
        if (propertiesAirSpace) {
          this.multiPlan = propertiesAirSpace.length > 0;
        }
      });

    this.toolboxMailMerge$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((toolboxMailMerge: ToolboxMailMergeState) => {
        // this.mailMergeForm.setValue({
        //   selectionMethod: toolboxMailMerge.selectionMethod,
        //   selectionBuffer: toolboxMailMerge.selectionBuffer
        // });
        this.toolboxMailMergeState = toolboxMailMerge;
      });

    this.getProfile();

    this.search = (text$: Observable<string>): Observable<SearchItem[]> => {
      return text$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          if (name.length > 0) {
            const encodedName = encodeURIComponent(name);
            return forkJoin({
              address: this.searchService
                .getSearchItems('api/gis/searchaddress/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              streets: this.searchService
                .getSearchItems('api/gis/searchstreets/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              parks: this.searchService
                .getSearchItems('api/gis/searchparks/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              intersections: this.searchService
                .getSearchItems('api/gis/searchitems/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              pid: this.searchService
                .getSearchItems('api/gis/searchpid/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              folio: this.searchService
                .getSearchItems('api/gis/searchfolio/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                )
              // drawings:
              //   this.searchService.getSearchItems('api/engNum/' + encodedName)
              //     .pipe(
              //       catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
              //         return of([]);
              //       }),
              //     ),
            });
          } else {
            return EMPTY;
          }
        }),
        map(itemsMap => {
          return [
            ...itemsMap.address,
            ...itemsMap.parks,
            ...itemsMap.streets,
            ...itemsMap.intersections,
            ...itemsMap.pid,
            ...itemsMap.folio //, ...itemsMap.drawings
          ];
        })
      );
    };

    this.engDrawSearchNum = (
      searchNum$: Observable<string>
    ): Observable<SearchItem[]> => {
      return searchNum$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          const encodedName = encodeURIComponent(name);
          if (name.length > 1 && name.indexOf(',') === -1) {
            this.searchingNum = true;
            return this.searchService
              .getSearchItems('api/engNum/' + encodedName)
              .pipe(
                finalize(() => (this.searchingNum = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                        {
                          name: 'no results',
                          assetId: '0',
                          id: 0,
                          type: SearchItemType.Drawing
                        } as SearchItem
                      ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingNum = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    this.engDrawSearchProj = (
      searchProj$: Observable<string>
    ): Observable<SearchItem[]> => {
      return searchProj$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        switchMap((name: string) => {
          this.searchingProj = true;
          const encodedName = encodeURIComponent(name);
          if (name.length > 1) {
            return this.searchService
              .getSearchItems('api/engproj/' + encodedName)
              .pipe(
                finalize(() => (this.searchingProj = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                        {
                          name: 'no results',
                          assetId: '0',
                          id: 0,
                          type: SearchItemType.Drawing
                        }
                      ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingProj = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    // this.circleRadius.valueChanges.pipe(
    //   debounceTime(500),
    //   distinctUntilChanged()
    // ).subscribe(() =>
    //   this.updateCircleRadius()
    // );

    this.store.dispatch(
      new GetBasemaps(`${this.configService.webApiEndpoint}basemap`)
    );
    this.store.dispatch(
      new SetMapState(this.configService.initialDnvMapState())
    );
    this.store.dispatch(new SetIcons(this.configService.initialSearchIcons()));
    this.store.dispatch(
      new GetLayers(`${this.configService.webApiEndpoint}layers`)
    );
    this.store.dispatch(
      new SetSearchItemsUrl(
        `${this.applicationState.appSettings['environment.searchApiEndpointUrl']}api/searchitems`
      )
    );

    if (this.mapState.featureLayers && this.mapState.featureLayers.length > 0) {
      this.store.dispatch(new LoadLegendLayers({ url: 'api/legends' }));
    }

    // this.store.dispatch(new DelayedActionBy1([
    //   new DelayedActionBy1([
    //     new MapViewLoad()
    //   ])
    // ]));

    this.store.dispatch(new LoadLegendLayers({ url: 'api/legends' }));

    this.appStoreWrapper = new AppStoreWrapper();
    this.store.dispatch(new MapViewSetStoreWrapper(this.appStoreWrapper));

    this.appUrlProvider = new AppUrlProvider(''); // Typically '' would work as an input here.
    this.store.dispatch(new MapViewSetUrlProvider(this.appUrlProvider));

    this.store.dispatch(
      new MapViewLoad({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper,
        selectedId: noLoadedMapView
      })
    );

    // Inspect the url - if a shared ID was provided, load it, otherwise load the user's default MapView
    // TODO inspect url here to pull in lat, lng and problemNo
    if (this.route.snapshot && this.route.snapshot.params) {
      if (
        this.route.snapshot.params['lat'] &&
        this.route.snapshot.params['lng']
      ) {
        this.store.dispatch(
          new CenterMap({
            lat: this.route.snapshot.params['lat'],
            lng: this.route.snapshot.params['lng']
          })
        );
        this.store.dispatch(new SetZoom(6));
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // Demo interceptor - obtain user profile
  getProfile(): void {
    this.httpClient
      .get(this.graphMeEndpoint)
      .toPromise()
      .then((profile: UserProfile) => {
        this.userProfile = profile;
        this.userIcon =
          profile.givenName.substring(0, 1).toUpperCase() +
          profile.surname.substring(0, 1).toUpperCase();
      });

    // this.httpClient.get('https://localhost:44308/api/user/info').toPromise()
    //   .then((data: any) => {
    //     console.log(data);
    //   });
  }

  logout(): void {
    // this.authService.logout();
    this.router.navigate(['/logout']);
  }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
    if (this.headerHeight === 0) {
      this.setHeaderHeight();
    }
    if (this.applicationState.windowInnerWidth > 767) {
      this.isDesktop = true;
    }
  }

  setHeaderHeight(): void {
    if (this.applicationState.windowInnerWidth > 767) {
      this.headerHeight = this.fixedHeader
        ? this.fixedHeader.nativeElement.clientHeight
        : 54;
      this.panelHeight =
        this.applicationState.windowInnerHeight - this.headerHeight;
      this.contentHeight = this.panelHeight - 47;
    } else {
      // mobile
      this.headerHeight = 60;
      this.panelHeight = this.applicationState.windowInnerHeight - 110;
    }
    this.inspectionHeight = this.panelHeight - 45;
  }

  // dnv-map event handlers

  onMapClick(coordinates: DnvMapInfo): void {
    //REturn click surrounding feature
    this.store.dispatch(new SetSurroundingFeatureList(null));
    this.store.dispatch(new SelectFeature(null));
    this.store.dispatch(new SetHighlightFeature(null));
    this.store.dispatch(new SetSurroundingFeature(false));
    this.store.dispatch(new ResetSelected());

    this.store.dispatch(new ToggleMetaDataPanel(false));
    this.dispatchIdentifySurroundingFeature(coordinates);
  }

  dispatchIdentifySurroundingFeature(coordinates: DnvMapInfo): void {
    if (this.layerState.layers.length > 0 && !this.selectedFeature) {
      const flIds: number[] = [];
      const wClauses: string[] = [];
      this.layerState.layers.forEach(layer => {
        if (layer.type === 0) {
          layer.featureLayers.forEach(featureLayer => {
            const flMinZoom = this.gisUtility.minZoomFromMinScale(
              featureLayer.minScale,
              0,
              this.mapState.resolutions
            );
            const flMaxZoom = this.gisUtility.maxZoomFromMaxScale(
              featureLayer.maxScale,
              this.mapState.resolutions.length - 1,
              this.mapState.resolutions
            );
            if (
              featureLayer.isVisible === true &&
              featureLayer.type.toLocaleLowerCase() !== 'tile' &&
              flMinZoom <= this.mapState.zoomLevel &&
              flMaxZoom >= this.mapState.zoomLevel
            ) {
              flIds.push(featureLayer.featureLayerId);
              if (featureLayer.whereClause !== '1=1') {
                wClauses.push(
                  featureLayer.featureLayerId + '\r' + featureLayer.whereClause
                );
              }
            }
          });
        }
      });

      if (flIds.length === 0) {
        return; // We don't need to query if there are no layers
      }

      const featureLayerIds = flIds.join(',');

      let whereClause = '';
      if (wClauses.length > 0) {
        whereClause = '&where=' + wClauses.join(',');
      }

      this.store.dispatch(
        new IdentifySurroundingFeature(
          `${this.configService.webApiEndpoint}identifyFeatures?latlng=` +
            coordinates.latlng.lng +
            `,` +
            coordinates.latlng.lat +
            `&northWestBound=` +
            coordinates.mapBounds.northWestBound.lat +
            `,` +
            coordinates.mapBounds.northWestBound.lng +
            `&southEastBound=` +
            coordinates.mapBounds.southEastBound.lat +
            `,` +
            coordinates.mapBounds.southEastBound.lng +
            `&imageDisplay=` +
            coordinates.mapSizeInPixel +
            `&layerNum=` +
            featureLayerIds +
            encodeURI(whereClause)
        )
      );
    }
  }

  onMoveChange(state: DnvMapState): void {
    this.store.dispatch(
      new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng })
    );
    // this.store.dispatch(new MapViewCheckIsDirty({
    //   urlProvider: this.appUrlProvider,
    //   storeWrapper: this.appStoreWrapper
    // }));
  }

  onZoomChange(state: DnvMapState): void {
    this.store.dispatch(new SetZoom(state.zoomLevel));
    // this.store.dispatch(new MapViewCheckIsDirty({
    //   urlProvider: this.appUrlProvider,
    //   storeWrapper: this.appStoreWrapper
    // }));
  }

  onMapUpdate(actions: DnvMapAction[]): void {
    this.store.dispatch(new DelayedAction(actions));

    // switch (action.type) {
    //   // case DnvMapActionType.AddedFeature:
    //   // case DnvMapActionType.DeleteFeature:
    //   // // case DnvMapActionType.UpdateFeature: ???
    //   // case DnvMapActionType.UpdateConversionUnit:
    //   // // case DnvMapActionType.StartDraw:
    //   // case DnvMapActionType.UpdateFeatureGeoCoord:
    //   //   this.store.dispatch(new MapViewMarkDirty());
    //   //   break;

    //   // case DnvMapActionType.ResetSelected:
    //   //   this.store.dispatch(new SetFeatureAttachment(null));
    //   //   this.store.dispatch(new SetInspection(null));
    //   //   break;

    //   // case DnvLayerActionType.SetInspFields:
    //   //   this.store.dispatch(new SetInspectionFields(action.payload));
    //   //   break;

    //   default:
    //     break;
    // }
  }

  onZoomToFeatures(featureFilterPayload: FeatureFilterPayload): void {
    this.store.dispatch(
      new ZoomToFeatures([featureFilterPayload.featureLayer])
    );
  }

  onUpdateFilter(featureFilterPayload: FeatureFilterPayload): void {
    this.store.dispatch(
      new InvalidateGridCache({
        dnvFeatureLayer: featureFilterPayload.featureLayer
      })
    );

    // If the grid is showing the featureLayer for which the filter is being modified, refresh the data
    if (
      this.applicationState.gridSelectLayer &&
      this.applicationState.gridSelectLayer.uid ===
        featureFilterPayload.featureLayer.uid
    ) {
      this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
      // this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: featureFilterPayload.featureLayer }));
    }
    this.store.dispatch(new UpdateLayerFilter(featureFilterPayload));
    // if (featureFilterPayload.geometry && featureFilterPayload.geometry.length > 0) {
    //   this.store.dispatch(new QueryLayerFeatureCountAOI(
    //     { filterPayload: featureFilterPayload, coordinates: featureFilterPayload.geometry }));
    // } else {
    this.store.dispatch(new QueryLayerFeatureCount(featureFilterPayload));
    // }

    // this.store.dispatch(new QueryLayerFeatureCount(featureFilterPayload));
    this.store.dispatch(new CheckLayerDisplay());

    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  hideFilterPanel(): void {
    this.store.dispatch(new HideFilterPanel());
  }

  onSetBaseMap(basemap: DnvBasemap): void {
    // const a: DnvBasemap[] = [basemap];
    // this.store.dispatch(new SetMapBasemaps(a));
    this.store.dispatch(new SetBaseMapSelected(basemap));
    // this.store.dispatch(new CloseBasemaps());
  }

  onSelectBasemap(basemap: DnvBasemap): void {
    this.store.dispatch(new SelectBasemap(basemap));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  onToggleShowFilterPanel(filterPayload: FeatureFilterPayload): void {
    if (!filterPayload.featureLayer.showFilterPanel) {
      this.store.dispatch(
        new DelayedActionBy1([new QueryLayerFeatureCount(filterPayload)])
      );
    }

    this.store.dispatch(new ToggleShowFilterPanel(filterPayload));
  }

  onLayersOrdered(evt: any): void {
    this.store.dispatch(evt);
    this.store.dispatch(new SetMapFeatureLayers(this.layerList(evt.payload)));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  setActiveLayer(layer: DnvLayer): void {
    this.store.dispatch(new SetActiveLayer(layer));
    this.store.dispatch(new CheckLayerDisplay());
    if (layer.layerInfo.length > 0) {
      this.store.dispatch(new SetLayerInfo(layer.layerInfo));
    } else {
      if (
        this.applicationState.toolboxStatus !==
        this.ToolboxStatus.ServiceConnections
      ) {
        this.store.dispatch(new SetLayerInfo(''));
      }
    }
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );

    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }
    this.initializeLegend();
  }

  setAvailableLayer(layer: DnvLayer): void {
    this.store.dispatch(new HideFilterPanel()); // TODO WIP fix this

    // if one of the layers currently being removed was the active grid, remove it
    if (this.applicationState.gridSelectLayer) {
      layer.featureLayers.forEach((featureLayer: any) => {
        if (
          this.applicationState.gridSelectLayer &&
          this.applicationState.gridSelectLayer.uid === featureLayer.uid
        ) {
          this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
        }
      });
    }
    this.store.dispatch(new SetAvailableLayer(layer));
    this.store.dispatch(new CheckLayerDisplay());
    // this.store.dispatch(new MapViewCheckIsDirty());
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );

    // remove filters when layer is removed
    this.store.dispatch(new ClearLayerFilters({ layer, hidden: [] }));

    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }

    // close feature panel if layer is being removed
    this.closeFeatureInformation();

    this.initializeLegend();
  }

  toggleBasemaps(): void {
    this.store.dispatch(new ToggleBasemaps());
  }

  toggleLayer(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    if (status !== ApplicationStatus.Layer) {
      this.store.dispatch(new Layer());
    } else {
      this.toIdle(status);
    }
  }

  toggleTable(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    if (status !== ApplicationStatus.Table) {
      this.store.dispatch(new Table());

      // As the table is openned, if no featureLayer is selected, load the first one
      if (!this.applicationState.gridSelectLayer) {
        // this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer:  }));
        const activeLayer = this.layerState.layers.find(
          layer => layer.type === LayerType.Active
        );
        if (
          activeLayer &&
          activeLayer.featureLayers &&
          activeLayer.featureLayers.length > 0
        ) {
          this.store.dispatch(
            new GridSelectLayer({
              dnvFeatureLayer: activeLayer.featureLayers[0]
            })
          );
        }
      }

      this.closeFeatureInformation();
    } else {
      this.toIdle(status);
    }
  }

  toggleLegend(status: ApplicationStatus): void {
    this.toIdle(status);
    this.toggleOffDraw();
    this.closePropertyInformation();
    if (status !== ApplicationStatus.Legend) {
      this.store.dispatch(new Legend());
      this.store.dispatch(new ToggleMetaDataPanel(false));
      this.initializeLegend();
    }
  }

  initializeLegend(): void {
    this.currentLayerInfo = undefined;
    const layers: DnvLayer[] = this.layerState.layers.filter(
      l => l.type === LayerType.Active
    );
    const featureLayers: DnvFeatureLayer[] = layers
      .map(l => l.featureLayers)
      .reduce(
        (accumulator, currentValue) => accumulator.concat(currentValue),
        []
      ) // Poor man's FlatMap
      .filter(fl => fl.isVisible);

    const activeLegend = [];

    const error: any[] = [];
    for (const fl of featureLayers) {
      if (Number(fl.gisLayerNum) >= 0) {
        const legend = this.legendState.legendCache.find(
          (l: any) =>
            Number(fl.gisLayerNum) === l.layerId && fl.name === l.layerName
        );
        if (legend) {
          activeLegend.push(legend);
        } else {
          error.push(fl.name);
        }
      } else {
        const legend = this.legendState.legendCache.find(
          (l: any) => fl.name === l.layerName
        );
        if (legend) {
          activeLegend.push(legend);
        } else {
          error.push(fl.name);
        }
      }
    }

    // console.log(activeLegend);
    if (error.length > 0) {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'fail',
          title: 'Legend',
          message:
            'There was a problem with the legend for the following layer(s): </br>' +
            error.join('</br>'),
          options: {
            disableTimeOut: true,
            closeButton: true,
            enableHtml: true
          }
        })
      );
    }

    this.store.dispatch(new SetActiveLegendLayers(activeLegend));
  }

  // toggleExport(status: ApplicationStatus): void {
  //   this.toggleOffDraw();
  //   this.closePropertyInformation();
  //   if (status !== ApplicationStatus.Export) {
  //     this.store.dispatch(new Export());
  //   } else {
  //     this.toIdle(status);
  //   }
  // }

  // toggleDraw(status: ApplicationStatus): void {
  //   this.toggleOffDraw();
  //   this.closePropertyInformation();
  //   if (this.drawBtn === 'delete') {
  //     this.toggleDelete();
  //   }
  //   if (status !== ApplicationStatus.Draw) {
  //     this.store.dispatch(new Draw()); // open panel
  //     // this.store.dispatch(new AddText(true)); // allow adding text
  //   } else {
  //     this.toIdle(status);
  //     this.store.dispatch(new AddText(false));
  //   }
  // }

  // toggleEngDraw(status: ToolboxStatus): void {
  //   this.closePropertyInformation();
  //   this.resetSVCLayers();
  //   if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
  //     this.togglePropertyInfo();
  //   }
  //   if (this.applicationState.windowInnerWidth > 767) {
  //     this.toggleOffDraw();
  //   }
  //   if (status !== ToolboxStatus.EngDrawing) {
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.EngDrawing)); // open panel
  //     if (this.applicationState.windowInnerWidth > 767) {
  //       this.isDesktop = true;
  //       this.store.dispatch(new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })]));
  //       this.store.dispatch(new Toolbox());
  //     } else {
  //       this.isDesktop = false;
  //     }
  //   } else {
  //     this.onClearEngSearch('num');
  //     this.onClearEngSearch('proj');
  //     // this.toIdle(status);
  //     if (this.isDesktop) {
  //       this.toggleOffDraw();
  //     }
  //     if (this.applicationState.windowInnerWidth > 767) {
  //       this.toggleToolbox(ApplicationStatus.Idle);  // should be something other than Toolbox to open panel
  //     }
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
  //   }
  // }

  // toggleCCTV(status: ToolboxStatus): void {
  //   this.closePropertyInformation();
  //   this.resetSVCLayers();
  //   if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
  //     this.togglePropertyInfo();
  //   }
  //   if (this.applicationState.windowInnerWidth > 767) {
  //     this.toggleOffDraw();
  //   }
  //   if (status !== ToolboxStatus.CCTV) {
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.CCTV)); // open panel
  //     if (this.applicationState.windowInnerWidth > 767) {
  //       this.isDesktop = true;
  //     } else {
  //       this.isDesktop = false;
  //     }
  //     // add layers
  //     const cctvLayers = this.layerState.layers.filter(l => l.name === 'CCTV');
  //     if (cctvLayers) {
  //       this.setActiveLayer(cctvLayers[0]);
  //     }
  //   } else {
  //     this.toggleToolbox(ApplicationStatus.Idle);
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
  //     // remove layers
  //     const cctvLayers = this.layerState.layers.filter(l => l.name === 'CCTV');
  //     if (cctvLayers) {
  //       this.setAvailableLayer(cctvLayers[0]);
  //     }
  //   }

  // }

  // toggleSvcConn(): void {
  //   const svcLayers = ['Sanitary Network', 'Water Network', 'Storm Network', 'Rights of Way and Easements'];
  //   this.closePropertyInformation();
  //   if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
  //     this.togglePropertyInfo();
  //   }
  //   if (this.applicationState.windowInnerWidth > 767) {
  //     this.toggleOffDraw();
  //   }
  //   if (this.applicationState.toolboxStatus !== ToolboxStatus.ServiceConnections) {
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.ServiceConnections)); // open panel

  //     //  console.log('DEBUG:', this);
  //     this.layerState.layers.forEach(layer => {
  //       if (svcLayers.includes(layer.name)) {
  //         this.setActiveLayer(layer);
  //       }

  //     });
  //   } else {
  //     // remove layers
  //     const activeLayers = this.layerState.layers.filter(l => l.type === 0);
  //     for (const l of activeLayers) {
  //       if (svcLayers.includes(l.name)) {
  //         this.setAvailableLayer(l);
  //       }
  //     }
  //     this.store.dispatch(new Toolbox());
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
  //     // this.toIdle(this.applicationState.status);
  //     // this.toggleToolbox(this.applicationState.status);
  //   }
  // }

  // toggleMailMerge(): void {
  //   this.resetSVCLayers();
  //   if (this.applicationState.windowInnerWidth > 767) {
  //     this.toggleOffDraw();
  //   }

  //   if (this.applicationState.toolboxStatus !== ToolboxStatus.MailMerge) {
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.MailMerge));
  //   } else {
  //     this.store.dispatch(new Toolbox());
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
  //     this.onMailLabelClearEmitter();
  //   }
  // }

  // toggleToolbox(status: ApplicationStatus): void {
  //   this.toggleOffDraw();
  //   if (status !== ApplicationStatus.Toolbox) {
  //     this.store.dispatch(new Toolbox());
  //   } else {
  //     // off
  //     this.toIdle(status);
  //   }
  // }

  toIdle(status: ApplicationStatus): void {
    switch (status) {
      // case ApplicationStatus.Idle:
      case ApplicationStatus.Error:
        break;
      default:
        this.store.dispatch(new Idle());
        this.store.dispatch(new ToggleEditShapes(false));
        break;
    }
  }

  layerList(layerState: DnvLayer[]): any {
    const activeFeatureLayers = layerState
      .filter(l => l.type === 0) // Only keep active layers
      .filter(l => this.currentZoomLevel >= l.minZoom) // Show all layer greater than current zoom level
      .map(l => l.featureLayers);
    return activeFeatureLayers.reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue),
      []
    ); // Poor man's FlatMap
  }

  onSelectItem(event: NgbTypeaheadSelectItemEvent): void {
    // intersection
    if (event.item.type === 4) {
      this.store.dispatch(new SearchCoordinates(event.item));
    } else if (event.item.type === 5 || event.item.type === 6) {
      // 5 = pid, 6 = folio
      this.store.dispatch(
        new GetDBLink({
          num: event.item,
          type: event.item.type === 5 ? 'pid' : 'folio'
        })
      );

      if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
        if (event.item.type === 5) {
          // pid
          this.store.dispatch(new GetPropertyByPID(event.item.name));
        }
        if (event.item.type === 6) {
          // folio
          this.store.dispatch(new GetPropertyByFolio(event.item.name));
        }
      }
    } else if (event.item.type === 7) {
      this.store.dispatch(
        new GetEngDrawingGeometry({ searchedItem: event.item, apisUrl: '' })
      );
    } else {
      const search: SearchedInfo = {
        searchedItem: event.item,
        apisUrl: `${this.applicationState.appSettings['environment.searchApiEndpointUrl']}api/geoinfo`
      };

      // search by address
      if (
        event.item.type === 1 &&
        this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo
      ) {
        this.store.dispatch(
          new GetPropertyByAddress({
            address: event.item.name,
            dblink: '',
            ltopid: '',
            search: true
          })
        );
        this.store.dispatch(new SetSelectedProperty(''));
      } else {
        // this returns a different shape than property info
        this.store.dispatch(new Search({ search: search }));
      }
    }
  }

  // onSelectEng(event: NgbTypeaheadSelectItemEvent): void {
  //   if (event.item.name !== 'no results') {
  //     if (event.item.assetId === 'name') {
  //       this.store.dispatch(new SearchEngineerDrawingsByProj(event.item.name));
  //     } else {
  //       this.store.dispatch(new SearchEngineerDrawingsByNum(event.item.name));
  //     }
  //   }
  // }

  onKeyDown(evt: any): void {
    evt.stopPropagation();
  }

  onBlur(): void {
    const locString = this.searchForm.get('addressSearch').value;
    if (typeof locString === 'string' && '' !== locString) {
      this.searchForm
        .get('addressSearch')
        .setValue({ name: locString, id: 0, type: '' });
    }
  }

  getClass(type: number): string {
    let result = this.defaultIcon;
    if (this.dnvSearchState.icons) {
      const icon = this.dnvSearchState.icons.find(
        (x: { id: number }) => x.id === type
      );
      if (icon) {
        result = icon.fontAwesome;
      }
    }
    return result;
  }

  // gridSelectLayer(featureLayer: DnvFeatureLayer): void {
  //   // console.log(layer);
  //   this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: featureLayer }));
  //   // delayed because if only one layer, panel stops half way as it's sliding up
  //   // this.store.dispatch(
  //   //   new DelayedActionBy1([
  //   //     new GridSelectLayer({ dnvFeatureLayer: layer })
  //   //   ])
  //   // );
  // }
  gridViewUpdate(action: Action): void {
    this.store.dispatch(action);
  }

  onClearClicked(): void {
    this.searchForm.get('addressSearch').setValue('');
    //this.store.dispatch(new SetMapGeoJsonLayers([]));
    this.store.dispatch(new SearchReset());
    this.store.dispatch(new SetMarkers([])); // To be investigated
  }

  onClearSearch(evt: any): void {
    const searchVal = evt.target.value;
    if (searchVal.length === 0) {
      //this.store.dispatch(new SetMapGeoJsonLayers([])); //should not dispatch this action
      this.store.dispatch(new SearchReset());
    }
  }

  onClearEngSearch(field: string): void {
    if (field === 'num') {
      this.engSearchForm.get('engDrawSearchNum').setValue('');
    } else {
      this.engSearchForm.get('engDrawSearchProj').setValue('');
    }
  }

  onClearCCTVSearch(): void {
    this.cctvSearchForm.get('cctvSearch').setValue('SANMN');
  }

  onToggleExpand(lyr: DnvLayer): void {
    this.store.dispatch(new ToggleExpand(lyr));
  }

  onHideLayer(payload: FeatureLayerVisibilityPayload): void {
    this.store.dispatch(new SetLayerFeatureVisible(payload));
    this.store.dispatch(new CheckLayerDisplay());
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }
  }
  onHideFeatureLayer(payload: FeatureLayerVisibilityPayload): void {
    this.onHideLayer(payload); // steps are identical in both case
    // this.store.dispatch(new SetLayerFeatureVisible(payload));
    // this.store.dispatch(new CheckLayerDisplay());
  }

  // onHideFeatureLayer(payload: ToggleVisiblePayload): void {
  //   this.store.dispatch(new SetFeatureLayerVisible(payload));
  // }

  // setLayerFeatures(action: Action): void {
  //   this.store.dispatch(action);
  // }

  onMetadataClick(layerInfo: LayerInfo): void {
    const featureLayer = this.mapState.featureLayers.find(
      fl => fl.name.toLowerCase() === layerInfo.layerName.toLowerCase()
    );
    this.store.dispatch(new GetDataNames(featureLayer.featureLayerId));
    if (this.currentLayerInfo === undefined) {
      this.store.dispatch(new ToggleMetaDataPanel());
    }
    this.currentLayerInfo = layerInfo;
  }

  hideMetaData(): void {
    this.store.dispatch(new ToggleMetaDataPanel());
    this.store.dispatch(new SetMetaData(null));
    this.currentLayerInfo = undefined;
  }

  highlightFeature(evt: { url: string; objectId: number }): void {
    this.store.dispatch(new SetHighlightFeature(evt));
    if (evt) {
      if (evt.url.indexOf('1=1') === -1) {
        // raster
        this.store.dispatch(new GetCoordsByObjectId(evt));
      }
    } else {
      if (!this.mapState.selectedFeature) {
        this.store.dispatch(new SetFeatureRasterHighlight({}));
        this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
      }
    }
  }

  closeFeatureInformation(): void {
    //   this.store.dispatch(new SetSurroundingFeatureList(null));
    //   this.store.dispatch(new SetHighlightFeature(null));
    //   this.store.dispatch(new SelectFeature(null));
    //   this.store.dispatch(new SetSurroundingFeature(false));
  }

  closePropertyInformation(): void {
    //   this.store.dispatch(new SetPropertyInfo([]));
    //   this.store.dispatch(new ResetGeoJsonProperty());
    //   // this.store.dispatch(new SetMapGeoJsonLayers([]));
    //   this.store.dispatch(new SetPropertiesDbLinks([]));
    //   this.store.dispatch(new SetSelectedProperty(''));
  }

  // closeServiceConnections(): void {
  //   this.store.dispatch(new SetPrintSvcConn(''));
  //   this.store.dispatch(new ResetGeoJsonProperty());
  //   // this.store.dispatch(new SetMapGeoJsonLayers([]));
  // }

  selectFeature(evt: {
    objectId: string;
    url: string;
    writeUrl: string;
    allowInsp: boolean;
    featureId: number;
    assetId: string;
  }): void {
    if (evt == null) {
      this.store.dispatch(new SelectFeature(null));
      // reset raster highlight
      this.store.dispatch(new SetFeatureRasterHighlight({}));
      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    } else {
      this.store.dispatch(new SetSurroundingFeature(true));

      this.store.dispatch(
        new GetFeatureData({
          featureUrl: `${
            this.configService.webApiEndpoint
          }getFeatureData?url=${evt.url +
            encodeURIComponent(
              '/query?f=json&outFields=*&returnGeometry=false&objectIds='
            ) +
            evt.objectId}`,
          url: evt.url
        })
      ); // NEEDED?

      this.store.dispatch(
        new SetSelectedFeatureLayer({
          // url: `${ this.configService.webApiEndpoint } layerProxy / MapServer / ${ featureId } /`,
          url: evt.url,
          allow_inspections: false,
          writeUrl: evt.writeUrl
        })
      );
      this.store.dispatch(
        new FeatureClicked({
          // url: `${this.configService.webApiEndpoint}layerProxy/MapServer/${featureId}/`,
          url: evt.url,
          objectId: evt.objectId,
          writeUrl: evt.writeUrl,
          // tableLayers: tableLayers,
          assetId: evt.assetId
          // excludeFeatureInfo: data.mapState.excludeFeatureInfo
        })
      );

      // highlight selected
      this.store.dispatch(
        new GetCoordsByObjectId({ url: evt.url, objectId: evt.objectId })
      );
    }
  }

  dismiss(): void {
    if (this.modal) {
      this.modal.dismiss();
    }
  }

  open(modal: TemplateRef<any>): void {
    const modalOptions: NgbModalOptions = {
      beforeDismiss: () => {
        setTimeout(() => {
          this.store.dispatch(new SetLayerInfo(''));
        }, 1000);
        return true;
      }
    };
    this.modal = this.modalService.open(modal, modalOptions);
  }

  // generateColors(): any {
  //   const colors = [];
  //   const result = [];
  //   const vals = ['00', '33', '66', '99', 'cc', 'ff'];
  //   let color = '';
  //   for (const val1 of vals) {
  //     for (const val2 of vals) {
  //       for (const val3 of vals) {
  //         color = '#' + val1 + val2 + val3;
  //         colors.push(color);
  //       }
  //     }
  //   }

  //   while (colors.length) {
  //     result.push(colors.splice(0, 6));
  //   }
  //   return result;
  // }

  // // when user uses swatch picker
  // changeComplete(evt: any): void {
  //   // console.log(evt);
  //   this.selectedColor = evt.data.hex;
  //   this.changeColor(this.selectedColor);
  // }

  // onSwatchHover(evt: any): void {
  //   // console.log(evt);
  //   this.color = evt.hex;
  // }

  // // for when user types in color
  // setColor(evt: any): any {
  //   // console.log(evt);
  //   if (evt.currentTarget.value.length === 0) {
  //     this.selectedColor = '#000000';
  //     evt.currentTarget.value = '#000000';
  //   } else {
  //     this.selectedColor = evt.currentTarget.value;
  //   }
  //   this.changeColor(this.selectedColor);

  // }

  // openSwatches(obj: any): void {
  //   obj.open();
  // }

  // changeColor(color: string): void {
  //   if (this.drawBtn === 'addText' || this.editingShape === 'addText') {
  //     this.store.dispatch(new SetTextStyle({ color: this.selectedColor }));
  //     this.updateTextStyle({ color: this.selectedColor });
  //     this.store.dispatch(new SetAllTextStyle({ ...this.mapState.textStyle, color: this.selectedColor }));
  //   } else {
  //     const activeShape = this.getActiveFeature();
  //     if (activeShape.length > 0) {
  //       this.store.dispatch(new UpdateShapeFeatureColor({ color: this.selectedColor }));
  //       this.store.dispatch(new MapViewMarkDirty());
  //     }
  //   }
  //   this.store.dispatch(new UpdateShapeOutlineColour(this.selectedColor));
  // }

  // getSize(min: number, max: number): number[] {
  //   const sizes = [];
  //   for (let i = min; i <= max; i = i + 1) {
  //     sizes.push(i);
  //   }
  //   return sizes;
  // }

  // setFontSize(evt: any): void {
  //   this.store.dispatch(new SetTextStyle({ fontSize: evt.currentTarget.value }));
  //   const selectedText = this.getSelectedTextMarkup();
  //   if (selectedText && selectedText.length > 0) {
  //     this.store.dispatch(new UpdateFeatureStyle({
  //       leafletId: selectedText[0].leafletId,
  //       style: { ...selectedText[0].style, fontSize: evt.currentTarget.value }
  //     }));
  //   }
  // }

  // setFontFace(evt: any): void {
  //   this.store.dispatch(new SetTextStyle({ fontFace: evt.currentTarget.value }));
  //   const selectedText = this.getSelectedTextMarkup();
  //   if (selectedText && selectedText.length > 0) {
  //     this.store.dispatch(new UpdateFeatureStyle({
  //       leafletId: selectedText[0].leafletId,
  //       style: { ...selectedText[0].style, fontFace: evt.currentTarget.value }
  //     }));
  //   }
  // }

  // getSliderValue(): void {
  //   this.store.dispatch(new SetTextStyle({ rotation: this.sliderControl.value }));
  //   // console.log(this.sliderControl.value);
  //   const selectedText = this.getSelectedTextMarkup();
  //   if (selectedText && selectedText.length > 0) {
  //     this.store.dispatch(new UpdateFeatureStyle({
  //       leafletId: selectedText[0].leafletId,
  //       style: { ...selectedText[0].style, rotation: this.sliderControl.value }
  //     }));
  //   }
  // }

  // toggleAddText(): void {

  //   if (this.drawBtn === 'addText') {
  //     this.store.dispatch(new AddText(false));
  //     this.drawBtn = 'cancel';
  //   } else {
  //     this.store.dispatch(new AddText(true));
  //     this.drawBtn = 'addText';
  //   }

  //   // cancels other drawing tools
  //   this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
  // }

  // editText(evt: any): void {
  //   this.editingShape = 'addText';
  // }

  // moveText(): void {
  //   this.editingShape = 'addText';
  // }

  // createPdf(): void {
  //   this.dnvMap.getPngBlob((blob) => {
  //     this.printService.createPdf(blob);
  //   });
  // }

  // toggleDrawline(): void {
  //   if (this.drawBtn === 'line') {
  //     this.toggleOffDraw();
  //   } else {
  //     this.store.dispatch(new StartDraw({ shape: 'line', guid: '' }));
  //     this.drawBtn = 'line';
  //   }
  //   this.resetDrawEdit();
  // }

  // togglePolygon(): void {
  //   if (this.drawBtn === 'polygon') {
  //     this.toggleOffDraw();
  //   } else {
  //     this.store.dispatch(new StartDraw({ shape: 'polygon', guid: '' }));
  //     this.drawBtn = 'polygon';
  //   }
  //   this.resetDrawEdit();
  // }

  // toggleMarker(): void {
  //   if (this.drawBtn === 'marker') {
  //     this.toggleOffDraw();
  //   } else {
  //     this.store.dispatch(new StartDraw({ shape: 'marker', guid: '' }));
  //     this.drawBtn = 'marker';
  //   }
  //   this.store.dispatch(new AddText(false));
  //   this.editingShape = '';
  // }

  // toggleCircle(): void {
  //   if (this.drawBtn === 'circle') {
  //     this.toggleOffDraw();
  //   } else {
  //     const radius = this.circleRadius.value;
  //     this.store.dispatch(new StartDraw({ shape: 'circleRadius', guid: '', radius: radius !== '' ? radius : 0 }));
  //     this.drawBtn = 'circle';
  //   }
  //   this.resetDrawEdit();
  // }

  // toggleRect(): void {
  //   if (this.drawBtn === 'delete') {
  //     this.toggleDelete();
  //   }
  //   if (this.drawBtn === 'eng-polygon') {
  //     this.toggleOffDraw();
  //   } else {
  //     this.store.dispatch(new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })]));
  //     this.drawBtn = 'eng-polygon';
  //     if (this.applicationState.windowInnerWidth < 767) {
  //       this.toggleEngDraw(ToolboxStatus.EngDrawing);
  //     }
  //   }
  //   this.store.dispatch(new AddText(false));

  // }

  // toggleDelete(): void {
  //   // this.toggleOffDraw();
  //   if (this.drawBtn === 'delete') {
  //     this.store.dispatch(new StartDraw({ shape: 'deleteoff', guid: '' }));
  //     this.drawBtn = 'cancel';
  //     this.store.dispatch(new IsDrawing(false));
  //   } else {
  //     this.store.dispatch(new IsDrawing(true));
  //     this.store.dispatch(new StartDraw({ shape: 'delete', guid: '' }));
  //     this.drawBtn = 'delete';
  //   }

  // }

  toggleOffDraw(): void {
    //   this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
    //   this.store.dispatch(new IsDrawing(false));
    //   this.store.dispatch(new AddText(false));
    //   this.drawBtn = 'cancel';
    //   this.closePropertyInformation();
  }

  // updateCircleRadius(): void {
  //   const radius = Number(this.circleRadius.value);
  //   if (radius > 0) {
  //     this.store.dispatch(new UpdateStartDrawCircle(radius));
  //   } else {
  //     // freeform
  //     this.store.dispatch(new UpdateStartDrawCircle(0));
  //   }
  //   this.store.dispatch(new UpdateCircleRadius(radius));

  // }

  closeFeedback(): void {
    this.hideFeedback = true;
    // this.setHeaderHeight();
  }

  // searchEngDrawings(latlngs: DnvLatLng[]): void {
  //   if (this.isDesktop) {
  //     this.store.dispatch(new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })]));
  //   }

  //   this.store.dispatch(new SearchEngineerDrawings(latlngs));
  // }

  // searchEng(): void {
  //   this.searchingNum = false;
  //   this.searchingProj = false;
  //   const searchNum = this.engSearchForm.get('engDrawSearchNum').value.name ? this.engSearchForm.get('engDrawSearchNum').value.name
  //     : this.engSearchForm.get('engDrawSearchNum').value;
  //   const searchProj = this.engSearchForm.get('engDrawSearchProj').value.name ? this.engSearchForm.get('engDrawSearchProj').value.name :
  //     this.engSearchForm.get('engDrawSearchProj').value;
  //   if (searchNum.length > 0) {
  //     this.store.dispatch(new SearchEngineerDrawingsByNum(searchNum));
  //   }
  //   if (searchProj.length > 0) {
  //     this.store.dispatch(new SearchEngineerDrawingsByProj(searchProj));
  //   }

  // }

  // searchCCTV(): void {
  //   let assetId = this.cctvSearchForm.get('cctvSearch').value;
  //   if (assetId.indexOf(',') > -1) {
  //     const tmpArr = assetId.split(',');
  //     const assetIdList = tmpArr.map((t: string) => '\'' + t + '\'');
  //     assetId = assetIdList.join(',');
  //   }
  //   this.store.dispatch(new SearchCCTV(assetId));
  // }

  onSetOpacity(e: any): void {
    this.store.dispatch(new SetFeatureLayersOpacity(e));
    this.layerOpacity = e;
  }

  // setLineStyle(lineStyle: string): void {
  //   // const lineStyle = evt.target.value;
  //   this.store.dispatch(new SetLineStyle(lineStyle));
  //   const activeShape = this.getActiveFeature();
  //   if (activeShape.length > 0) {
  //     this.store.dispatch(new UpdateFeatureLineStyle({ lineStyle }));
  //     this.store.dispatch(new MapViewMarkDirty());
  //   }
  // }

  // setMarker(markerShape: string): void {
  //   const activeShape = this.getActiveFeature();
  //   if (activeShape.length > 0) {
  //     this.store.dispatch(new UpdateShapeFeatureMarker({ markerShape }));
  //     this.store.dispatch(new MapViewMarkDirty());
  //   }

  //   this.store.dispatch(new UpdateMarkerShape(markerShape));
  // }

  // changePattern(pattern: string): void {
  //   this.store.dispatch(new SetFillPattern(pattern));
  //   const activeShape = this.getActiveFeature();
  //   if (activeShape.length > 0) {
  //     this.store.dispatch(new UpdateShapeFillPattern({ pattern }));
  //     this.store.dispatch(new MapViewMarkDirty());
  //   }
  // }

  // toggleEdit(): void {
  //   this.store.dispatch(new ToggleEditShapes(true));
  //   this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
  //   this.store.dispatch(new AddText(false));
  //   if (this.mapState.editShapes) {
  //     this.drawBtn = 'edit';
  //   }
  // }

  // onShapeClick(evt: any): void {
  //   this.editingShape = evt.shape;

  //   if (evt.shapeStyle) {
  //     this.store.dispatch(new UpdateShapeOutlineColour(evt.shapeStyle.color));

  //     if (evt.shape === 'circle') {
  //       this.store.dispatch(new SetFillPattern(evt.shapeStyle.pattern));
  //       this.store.dispatch(new UpdateCircleRadius(0));
  //     } else if (evt.shape === 'marker') {
  //       this.store.dispatch(new UpdateMarkerShape(evt.shapeStyle.markerShape));
  //     } else if (evt.shape === 'LineString') {
  //       this.store.dispatch(new SetLineStyle(evt.shapeStyle.lineStyle));
  //     } else if (evt.shape === 'Polygon') {
  //       this.store.dispatch(new SetFillPattern(evt.shapeStyle.pattern));
  //     }
  //   }
  // }

  resetDrawEdit(): void {
    this.store.dispatch(new AddText(false));
    this.editingShape = '';
  }

  // updateTextStyle(textStyle: any): void {
  //   const selectedFeature = this.mapState.features.filter(f => f.properties.isSelected === true);
  //   if (selectedFeature.length > 0) {
  //     if (selectedFeature[0].textMarkup) {
  //       this.store.dispatch(new UpdateFeatureStyle({
  //         style: {
  //           ...selectedFeature[0].style,
  //           color: textStyle.color
  //         }, leafletId: selectedFeature[0].leafletId
  //       }));
  //     }
  //   }
  // }

  getActiveFeature(): any {
    return this.mapState.features.filter(f => f.properties.isSelected);
  }

  getSelectedTextMarkup(): DnvDrawnShapes[] {
    if (this.mapState.features) {
      return this.mapState.features.filter(
        f => f.properties.isSelected && f.textMarkup
      );
    }
  }

  bringToFront(): void {
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected
    );
    if (selectedShape && selectedShape.length > 0) {
      this.store.dispatch(new BringToFront(selectedShape[0].leafletId));
    }
    // resets value
    this.store.dispatch(new BringToBack(0));
  }

  bringToBack(): void {
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected
    );
    if (selectedShape && selectedShape.length > 0) {
      this.store.dispatch(new BringToBack(selectedShape[0].leafletId));
    }
    // resets value
    this.store.dispatch(new BringToFront(0));
  }

  onClearActiveLayer(layerState: DnvLayer[]): void {
    layerState.forEach(l => {
      if (l.type.toString() === '0') {
        this.store.dispatch(new SetAvailableLayer(l));
        this.store.dispatch(new ClearLayerFilters({ layer: l, hidden: [] }));
      }
    });
    this.store.dispatch(new CheckLayerDisplay());
    this.initializeLegend();
  }

  // togglePropertyInfo(): void {
  //   this.resetSVCLayers();
  //   if (this.applicationState.toolboxStatus !== ToolboxStatus.PropertyInfo) {
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.PropertyInfo));
  //     if (!this.isDesktop) {
  //       this.toggleToolbox(ApplicationStatus.Toolbox);
  //     }
  //   } else {
  //     this.closePropertyInformation();
  //     this.store.dispatch(new Toolbox());
  //     this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
  //     this.store.dispatch(new ResetGeoJsonProperty());
  //   }
  //   /*this.store.dispatch(new SetToolboxStatus(ToolboxStatus.PropertyInfo));
  //   if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
  //     if (!this.isDesktop) {
  //       this.toggleToolbox(ApplicationStatus.Toolbox);
  //     }
  //   }*/
  // }

  print(): void {
    window.print();
  }

  setAddress(address: string, dbLink: string): void {
    this.propertiesInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      // tslint:disable-next-line: deprecation
      .subscribe((propertiesInfo: PropertyInfo[]) => {
        if (propertiesInfo && propertiesInfo[0]) {
          if (propertiesInfo[0].propertyCount > 1) {
            const property = propertiesInfo[0].properties.find(p =>
              p.addresses.find(a => a.fullAddress === address)
            );
            this.dblink = property.dbLink;
            this.ltopid = property.ltopid;
          } else {
            this.dblink = propertiesInfo[0].properties[0].dbLink;
            this.ltopid = propertiesInfo[0].properties[0].ltopid;
          }
        }
      });
    this.store.dispatch(
      new GetPropertyByAddress({
        address,
        dblink: dbLink ? dbLink : this.dblink,
        ltopid: this.ltopid,
        search: false
      })
    );
    this.store.dispatch(new SetSelectedProperty(address));
  }

  // openDrawing(payload: { drawNum: string, drawType: string }): void {
  //   this.store.dispatch(new SearchEngineerDrawingsByNumType(payload));
  // }

  GetMultipleResults(dblink: string): void {
    if (this.multiPlan) {
      let lat = 0;
      let lng = 0;
      this.propertiesInfo$
        .pipe(takeUntil(this.ngUnsubscribe))
        // tslint:disable-next-line: deprecation
        .subscribe((propertiesInfo: PropertyInfo[]) => {
          if (
            propertiesInfo &&
            propertiesInfo[0] &&
            propertiesInfo[0].properties[0].details
          ) {
            lat = propertiesInfo[0].properties[0].details.geography.latitude;
            lng = propertiesInfo[0].properties[0].details.geography.longitude;
          }
        });
      this.store.dispatch(new GetPropertyByXY({ lat, lng }));
    } else {
      this.store.dispatch(new GetPropertyInfo(dblink));
    }
  }

  GetPropertyByDbLink(dblink: string): void {
    this.store.dispatch(new GetPropertyInfo(dblink));
    this.store.dispatch(new GetShape(dblink));
    this.store.dispatch(new SetSelectedProperty(''));
  }

  // BackToPlansOrClose(): void {
  //   if (this.multiPlan) {
  //     this.store.dispatch(new SetPropertyInfo([]));
  //     // this.store.dispatch(new SetMapGeoJsonLayers([]));
  //     this.store.dispatch(new SetSelectedProperty(''));
  //   } else {
  //     this.closePropertyInformation();
  //   }
  // }

  onFilterAOI(evt: any): void {
    // if (evt.action === 'select') {
    //   this.store.dispatch(new IsDrawing(true));
    // } else {
    //   if (this.filterAOILeafletId && this.filterAOILeafletId > 0) {
    //     this.store.dispatch(new DeleteFeature(this.filterAOILeafletId));
    //   }
    //   this.store.dispatch(new IsDrawing(false));
    //   this.store.dispatch(new SetFilterAOIShape({}));
    //   this.store.dispatch(new QueryLayerFeatureCount(evt.featurefilterpayload));
    // }

    // this.store.dispatch(new SetFilterAOIMode(evt));
    // this.store.dispatch(new CheckLayerDisplay());

    if (evt.action === 'select') {
      this.store.dispatch(new IsDrawing(false));
      this.store.dispatch(new SetFilterAOIShape({} as DnvDrawnShapes));

      this.store.dispatch(
        new SetFilterAOIMode({
          action: 'clear',
          featureLayerId: null,
          shape: null,
          showingAOIShape: true
        })
      );
      this.store.dispatch(new IsDrawing(true));
    } else if (evt.action === 'clear') {
      if (this.filterAOILeafletId && this.filterAOILeafletId > 0) {
        this.store.dispatch(new DeleteFeature(this.filterAOILeafletId));
      }
      this.store.dispatch(new IsDrawing(false));
      this.store.dispatch(new SetFilterAOIShape({} as DnvDrawnShapes));
    }

    this.store.dispatch(new SetFilterAOIMode(evt));
  }

  // closeCCTV(): void {
  //   this.store.dispatch(new SetCCTV([]));
  // }

  // onInspectionEmit(inspection: SelectedFeatureInspection): void {
  //   this.store.dispatch(new SetCCTV([inspection]));
  // }

  // onSearchCCTV(assetId: string): void {
  //   this.store.dispatch(new SearchCCTV(assetId));
  // }

  // printMap(evt: any): void {
  //   this.mapBorder = evt.borderEnabled;
  //   // this.dnvMap.printControl.options.manualMode = true;
  //   if (evt.mode === 'portrait') {
  //     this.dnvMap.printControl.print((L.control.browserPrint as any).mode.portrait());
  //   } else if (evt.mode === 'landscape') {
  //     this.dnvMap.printControl.print((L.control.browserPrint as any).mode.landscape());
  //   } else {
  //     this.dnvMap.printControl.print((L.control.browserPrint as any).mode.custom());
  //   }

  //   (this.dnvMap as any).map.on('browser-print', function () {
  //     const gridPrint = this.printControl.__overlay__.querySelector('.grid-print-container');
  //     if (evt.borderEnabled) {
  //       if (gridPrint) {
  //         gridPrint.classList.add('border');
  //       }
  //     } else {
  //       if (gridPrint) {
  //         gridPrint.classList.remove('border');
  //       }
  //     }

  //   });

  // }

  // onChangeMapTitle(evt: string): void {
  //   this.mapTitle = evt;
  // }

  // onChangeMapSubtitle(evt: string): void {
  //   this.mapSubTitle = evt;
  // }

  getToolboxTitleText(): string {
    //   if (this.applicationState.status !== this.ApplicationStatus.Toolbox
    //     && this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
    //     return 'Property Information is active';
    //   } else if (this.applicationState.toolboxStatus === this.ToolboxStatus.ServiceConnections) {
    //     return 'Service Connections is active';
    //   } else if (this.applicationState.toolboxStatus === this.ToolboxStatus.MailMerge) {
    //     return 'Mail Merge is active';
    //   } else {
    return 'Toolbox';
    //   }
  }

  // openReport(dblink: string): void {
  //   this.store.dispatch(new PrintSvcConn(dblink));
  // }

  // highlightServiceConnection(name: string, objectId: number) {
  //   this.layerState.layers.forEach(layer => {
  //     layer.featureLayers.forEach(featureLayer => {
  //       if (featureLayer.name === name) {
  //         console.log(featureLayer);
  //         this.store.dispatch(new SetHighlightFeature({ url: featureLayer.url + featureLayer.whereClause, objectId: objectId }));
  //       }
  //     });
  //   });
  // }

  // onMailLabelDraw() {
  //   if (this.toolboxMailMergeState.selectionMethod !== 'area') {
  //     const guid = Guid.create().toString();
  //     this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

  //     this.store.dispatch(
  //       new ToolboxMailMerge({
  //         toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, { selectionMethod: 'area' }),
  //         invalidate: true
  //       })
  //     );

  //     this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));

  //   }
  // }

  // onMailLabelSelect() {
  //   // this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
  //   // this.store.dispatch(new IsDrawing(false));
  //   // mailMergeSelect() {
  //   if (this.toolboxMailMergeState.selectionMethod !== 'property') {
  //     const guid = Guid.create().toString();
  //     this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
  //     this.store.dispatch(new IsDrawing(false));

  //     this.store.dispatch(
  //       new ToolboxMailMerge({
  //         toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, { selectionMethod: 'property' }),
  //         invalidate: true
  //       })
  //     );

  //     this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));

  //   }
  // }

  // onMailLabelClearEmitter() {
  //   let guid = '';

  //   if (this.toolboxMailMergeState.selectionMethod === 'area') {
  //     guid = Guid.create().toString();
  //     this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
  //     this.store.dispatch(new IsDrawing(false));

  //     guid = Guid.create().toString();
  //     this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

  //     this.store.dispatch(
  //       new ToolboxMailMerge({
  //         toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, { selectionMethod: 'area' }),
  //         invalidate: true
  //       })
  //     );
  //   } else if (this.toolboxMailMergeState.selectionMethod === 'property') {
  //     this.store.dispatch(
  //       new ToolboxMailMerge({
  //         toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, { selectionMethod: 'property' }),
  //         invalidate: true
  //       })
  //     );
  //   }

  //   this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
  // }

  // onMailMergeBufferChange(value: number) {

  //   this.store.dispatch(
  //     new ToolboxMailMerge({
  //       toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, { selectionBuffer: value }),
  //       invalidate: false
  //     })
  //   );

  //   if (this.toolboxMailMergeState.area.json) {
  //     this.store.dispatch(
  //       new ToolboxMailMergeArea(this.toolboxMailMergeState.area)
  //     );
  //   }

  // }

  onOrthoOpacityChange(value: number): void {
    this.store.dispatch(new SetOrthoOpacity(value));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  redirectToRap() {
    const assetId = this.applicationState.kvSections[0].kvPair[0][1];
    const problemNo = this.route.snapshot.params['problemNo'];
    const selectedFeatureLayerUrl = this.mapState.selectedFeatureLayer.url;
    const uId = this.mapState.featureLayers.filter(f => {
      if (f.url === selectedFeatureLayerUrl) {
        return f;
      }
    })[0].uid;

    if (uId.length > 0) {
      window.location.href =
        `${this.applicationState.appSettings['environment.rapEndpoint']}problemdetails?` +
        'ProblemNo=' +
        problemNo +
        '&AssetId=' +
        assetId +
        '&UId=' +
        uId;
    }
  }

  // downloadMailLabels(evt: any): void {
  //   // console.log(evt);

  //   // const dbLinks = this.toolboxMailMergeState.selectedParcels.map(p => p.url);
  //   // this.store.dispatch(new GetMailMergeList({ links: dbLinks, toOwners: evt.toOwners, toOccupants: evt.toOccupants, preferOwnerName: evt.preferOwnerName, groupOwners: evt.groupOwners }));

  //   this.store.dispatch(new GetMailMergeList());
  //   // if (this.applicationState.mailMergeList.length > 0) {

  //   //   const labelsList = this.applicationState.mailMergeList;
  //   //   const headerKey = ['name', 'address', 'underConstruction'];
  //   //   const header = ['Name', 'Address', 'Under Construction'];
  //   //   const replacer = (key: string, value: any) => (value === null ? '' : value);
  //   //   const csv = labelsList.map((row: any) =>
  //   //     headerKey
  //   //       .map((fieldName: string) =>
  //   //         JSON.stringify(this.getValue(fieldName, row), replacer))
  //   //       .join(',')
  //   //   );

  //   //   csv.unshift(header.join(','));
  //   //   const labelListArray = csv.join('\r\n');
  //   //   const blob = new Blob([labelListArray], { type: 'text/csv' });

  //   //   saveAs(blob, 'address-labels.csv');
  //   // }
  // }

  // onMailLabelOptionsEmitter(evt: ToolboxMailMergeOptions): void {
  //   this.store.dispatch(new ToolboxMailMergeUpdateOptions(evt));
  // }

  // resetSVCLayers(): void {
  //   // remove service connections layers
  //   const svcLayers = ['Sanitary Network', 'Water Network', 'Storm Network', 'Rights of Way and Easements'];

  //   const svcLyrs = this.layerState.layers.filter(l => svcLayers.includes(l.name));
  //   if (svcLyrs) {
  //     svcLyrs.forEach(s => {
  //       this.setAvailableLayer(s);
  //     });

  //   }
  // }
}
